import { StyleSheet, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import Bullet from '@/components/Bullet';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Link, RelativePathString } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { AppText } from '@/components/AppText';
import * as AppUtilities from '@/utilities/AppUtilities';
import { useMemo } from 'react';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 20,
    gap: 20,
  },
  item: {
    flexDirection: 'row',
    gap: 20,
    flexWrap: 'wrap',
    flexShrink: 1,
    alignItems: 'center',
  },
  linkItem: {
    flexDirection: "row",
    gap: 20,
  },
});

const POLICIES = [
  {
    href: "/terms",
    bulletId: 1,
    label: "Terms & Conditions",
  },
  {
    href: "/guidelines",
    bulletId: 2,
    label: "Community Guidelines",
  },
  {
    href: "/refunds",
    bulletId: 3,
    label: "Refunds",
  },
  {
    href: "/complaints",
    bulletId: 4,
    label: "Complaints policy",
  },
  {
    href: "/appeals",
    bulletId: 5,
    label: "Appeals policy",
  },
  {
    href: "/privacy",
    bulletId: 6,
    label: "Privacy Policy",
  },
  {
    href: "/dataprocessing",
    bulletId: 7,
    label: "Data Processing Agreement",
  },
  {
    href: "/csae",
    bulletId: 1,
    label: "Child Sexual Abuse and Exploitation Policy",
  },
  {
    href: "/human_trafficking",
    bulletId: 2,
    label: "Anti-human trafficking & content compliance policy",
  },
];

export default function Policies() {

  const policies = useMemo(() => {
    return (
      <>
        {
          POLICIES.map((item) => (
            <Link href={item.href as RelativePathString} key={item.href}>
              <View style={styles.linkItem}>
                <Bullet id={item.bulletId} />
                <AppText style={CustomTextStyles.link}>{item.label}</AppText>
              </View>
            </Link>
          ))
        }
      </>
    );
  }, [])

  return (
    <BasicScrollView center={false}>
      <Meta title={"Policies"} />
      <View style={styles.wrapper}>
        { policies }
      </View>
      <Footer />
    </BasicScrollView>
  );
}
